export const contactEmail = "info@pawpaw.com";
export const contactPhone = "+1234567890";

export const facebook = "https://www.facebook.com/";
export const instagram = "https://www.instagram.com/";
export const twitter = "https://twitter.com/";
